import { useQuery } from 'react-query';
import FilesAPI from '../Api/files';

interface VideoFile {
  read: string;
  thumbnail?: string;
}

export type VideoFiles = Record<string, VideoFile>;

export const useGetPublicVideos = () =>
  useQuery<VideoFiles, Error>(['video-requests'], () =>
    FilesAPI.getVideoFiles(),
  );
